import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import EditContent from './EditContent';
import {
  SLEditModal,
  SLCreateModal,
} from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from "react-redux";

export default function Perfil() {
  const [data, setData] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [analistas, setAnalistas] = useState([]);
  const [analistaFiltro, setAnalistaFiltro] = useState([]);

  useEffect(() => {
    setLoadedData(false);
  }, [analistaFiltro]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));

      api.get("/signed/empresa/gestorprojeto/gerencia/analistas", { params: { ativo: 1 } })
        .then(response => setAnalistas(response.data));

      setAnos([
        { id: new Date().getFullYear() - 2 },
        { id: new Date().getFullYear() - 1 },
        { id: new Date().getFullYear() },
      ])
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <SLCreateModal
            menu={true}
            defaultAtivo={true}
            title="Atualizar Senha"
            setter={setMountedData}
          >
            <EditContent />
          </SLCreateModal>
        </div>
      </LandPage>
    </Main>
  );
}
